module.exports = __webpack_public_path__ + "static/media/male_demon.36ac4ce5.png";